export default function(floatTime) {
  if (floatTime === 0.5) return "30 minutter";
  else if (floatTime === 1) return "1 time";
  else if (floatTime === 1.5) return "1 time og 30 minutter";
  else if (floatTime === 2) return "2 timer";
  else return "";
}
